let global = {
  data() {
    return {
      // LOCAL STORAGE
      storage: {
        colorFilter: [],
        designTypeFilters: [],
        roomTypeFilter: [],
        categoryFilter: [],
        designsPage: 0,
        chosenColor: colorChoices[0],
        chosenShape: shapeChoices[0],
        chosenPattern: patternChoices[0],
        transition: false,
        semiPermanent: [],
        startLogin: false,
        userEmail: null,
        wishlistCache: null,
        wishlistDesigns: [],
        subscribeLogin: false,
        variationsReady: false,
        createTiles: [
          {
            color: "Aries",
            pattern: "Blank",
            quantity: 1,
            shape: "Tile",
          },
        ],
        createSamples: [
          {
            color: "Aries",
            quantity: 1,
          },
        ],
      },

      cart: {
        items: [],
        total_price: 0,
      },
      grabbingCart: false,

      designs: [],
      grabbingDesigns: false,
      variationDetails: {},
      renderFilters: true,

      shapeChoices: shapeChoices,
      colorChoices: colorChoices,
      patternChoices: patternChoices,
      sampleVariations: sampleVariations,

      designCategories: [],
      searchCategory: null,
      showBreakout: null,
      commercialTabs: false,
      upsells: [],
      addingUpsell: false,
      discountMessages: [],
      freeShipMinimum: 99,
      design_links: [],
      checkingOut: false,

      togglingWishlist: false,

      totalAdhesiveSheets: 0,
      totalRegularSheets: 0,
      totalCommercialSheets: 0,
      totalMiniAdhesives: 0,

      variantTitle: {},
      variantPricing: {},
      variantImage: {},
      variantData: {},
      productDetails: {},

      draggable_tiles: null,

      addingDraggable: false,

      customerEmail: customerEmail,
      user: null,

      colorways: [
        {
          label: "Restore",
          labelIMG:
            "https://cdn.shopify.com/s/files/1/0091/0272/1104/files/Restore.png?v=1707308360",
          img: "https://cdn.shopify.com/s/files/1/0091/0272/1104/files/RestoreIMG.jpg?v=1707308361",
          description: "Deep greens combined with blue greens and neutrals.",
        },
        {
          label: "Focus",
          labelIMG:
            "https://cdn.shopify.com/s/files/1/0091/0272/1104/files/Focus_ca2c86e8-da4c-4028-856f-56874e5704c4.png?v=1707308361",
          img: "https://cdn.shopify.com/s/files/1/0091/0272/1104/files/FocusIMG.jpg?v=1707308361",
          description: "A mix of light and dark neutrals along with blue hues.",
        },
        {
          label: "Calm",
          labelIMG:
            "https://cdn.shopify.com/s/files/1/0091/0272/1104/files/Calm.png?v=1707308360",
          img: "https://cdn.shopify.com/s/files/1/0091/0272/1104/files/CalmIMG.jpg?v=1707308361",
          description:
            "Light, warm and cool neutrals w/ subtle organic patterning.",
        },
        {
          label: "Energize",
          labelIMG:
            "https://cdn.shopify.com/s/files/1/0091/0272/1104/files/Energize.png?v=1707308360",
          img: "https://cdn.shopify.com/s/files/1/0091/0272/1104/files/EnergizeIMG.jpg?v=1707308361",
          description:
            "Bright, highly saturated colors great for geometric patterns.",
        },
        {
          label: "Create",
          labelIMG:
            "https://cdn.shopify.com/s/files/1/0091/0272/1104/files/Create.png?v=1707308360",
          img: "https://cdn.shopify.com/s/files/1/0091/0272/1104/files/CreateIMG.jpg?v=1707308361",
          description:
            "Rich jewel tones especially inspirational for creativity.",
        },
        {
          label: "Play",
          labelIMG:
            "https://cdn.shopify.com/s/files/1/0091/0272/1104/files/Play.png?v=1707308360",
          img: "https://cdn.shopify.com/s/files/1/0091/0272/1104/files/PlayIMG.jpg?v=1707308361",
          description: "A set of bright hues meant to inspire playfulness.",
        },
      ],
    };
  },

  async mounted() {
    if (localStorage.storage) {
      this.storage = Object.assign(
        this.storage,
        JSON.parse(localStorage.storage)
      );
    }
    this.grabVariations();

    this.bus.$on("variationDetailsReady", (variations) => {
      for (let variation of variations) {
        this.variationDetails[variation.label] = variation;
        this.variantTitle[variation.variant_id] = variation.label;
        this.variantPricing[variation.variant_id] = variation.price * 100;
        this.variantImage[variation.variant_id] = variation.photo;
        this.variantData[variation.variant_id] = variation;
      }
      this.variationsReady = true;
      this.bus.$emit("variationsPrepped");
    });
  },

  watch: {
    storage: {
      deep: true,
      handler(newStorage) {
        localStorage.storage = JSON.stringify(this.storage);
      },
    },
  },

  computed: {
    visibleCartItems() {
      return this.cart.items.filter((item) => {
        let showItem = true;

        let hiddenItems = [
          "Adhesive Tab",
          "Commercial Adhesive Tab",
          "Mini Adhesive Tab",
        ];

        if (hiddenItems.includes(item.title)) {
          showItem = false;
        }

        return showItem;
      });
    },

    colorPalettes() {
      return this.designCategories.filter((category) => {
        if (category.color_palette) {
          return category;
        }
      });
    },

    paletteGroups() {
      let numGroups = this.colorPalettes.length / 4;
      let array = [];

      for (let i = 0; i < numGroups; i++) {
        array.push(parseFloat(i) * 4);
      }
      return array;
    },
  },

  methods: {
    uneditableInCart(item) {
      let titles = [];
      return titles.some((title) => item.title.includes(title));
    },

    async loginEmail() {
      // console.log(this.userEmail, "logging in with email");
      this.setCookie("_feltRightCustomerEmail", this.userEmail);
      this.customerEmail = this.userEmail;
      this.startLogin = false;
      await this.getUser();
      if (!this.user.wishlist.includes(this.wishlistCache.id)) {
        this.toggleWishlist(this.wishlistCache);
      }

      if (this.subscribeLogin) {
        axios.post("https://studio.feltright.com/subscribe-newsletter", {
          email: this.user.email,
        });
      }
    },

    toggleWishlist(design) {
      this.togglingWishlist = true;
      this.wishlistCache = null;
      if (!this.user) {
        this.startLogin = true;
        this.wishlistCache = design;
        return;
      }

      if (!this.user.wishlist.includes(design.id)) {
        this.user.wishlist.push(design.id);
      } else {
        this.user.wishlist.splice(this.user.wishlist.indexOf(design.id), 1);
      }

      axios
        .post("https://studio.feltright.com/toggle-wishlist", {
          design_id: design.id,
          email: this.user.email,
        })
        .then((response) => {
          this.togglingWishlist = false;
          this.$forceUpdate();
        });
    },

    async getWishlistDesigns() {
      return new Promise((resolve) => {
        axios
          .post("https://studio.feltright.com/load-designs", {
            ids: this.user.wishlist,
          })
          .then((response) => {
            this.wishlistDesigns = response.data;
            resolve(true);
          });
      });
    },

    async getUser() {
      return new Promise((resolve) => {
        if (this.user) return resolve(true);

        if (this.customerEmail) {
          axios
            .post("https://studio.feltright.com/get-user", {
              email: this.customerEmail,
            })
            .then((response) => {
              this.user = response.data;
              resolve(true);
            });
        }
      });
    },

    saveUser(data) {
      axios.post("https://studio.feltright.com/save-user", data);
    },

    isDesktop() {
      try {
        if (window) {
          return window.innerWidth > 1000;
        } else {
          return true;
        }
      } catch (error) {
        return true;
      }
    },

    addBundleProductWithTag(design) {
      this.addingDraggable = true;

      axios
        .post("https://studio.feltright.com/load-design", { id: design.id })
        .then((response) => {
          this.draggable_tiles = response.data.tiles;
          axios
            .get(`/products/${design.bundle_product}.js`)
            .then((response) => {
              let bundle_product_id = response.data.variants[0].id;
              this.addBundleProductToCart(bundle_product_id);
            });
        });
    },

    addBundleProductToCart(id) {
      this.addingDraggable = true;
      axios
        .post("https://studio.feltright.com/check-bundle-price", {
          variant_id: id,
          price: this.totalDraggable(this.draggable_tiles),
        })
        .then((response) => {
          Shopify.addItem(id, this.quantity, (response) => {
            // this.addedProductToCart = true;
            this.addingDraggable = false;
            this.showCart();
            this.bus.$emit("refreshCart");
            this.$forceUpdate();
          });
        });
    },

    freeShipping() {
      if (!this.cart) return false;
      let qualifies = false;

      if (this.cart.total_price / 100 >= this.freeShipMinimum) {
        qualifies = true;
      }

      let freeShipItems = [
        "adhesive-tab",
        "balance-coaster-sample-pack",
        "restore-coaster-sample-pack",
        "focus-coaster-sample-pack",
        "create-coaster-sample-pack",
        "energize-coaster-sample-pack",
        "calm-coaster-sample-pack",
        "custom-coaster-pack",
        "custom-sample-pack",
        "sample-pack",
      ];
      let allFreeShip = true;
      for (let item of this.cart.items) {
        if (!freeShipItems.includes(item.handle)) {
          allFreeShip = false;
          break;
        }
      }
      if (allFreeShip) qualifies = true;

      return qualifies;
    },

    saveCart() {
      Shopify.getCart(async (cart) => {
        axios
          .post("https://studio.feltright.com/save-cart", { items: cart.items })
          .then((response) => {
            Swal.fire({
              icon: "success",
              title: "Saved",
              html: `Your cart has been saved, use this url to access this cart again: <br> <p style="background: rgba(0,0,0,0.3); padding: 10px; border-radius: 5px;">https://feltright.com/cart?saved_cart=${response.data.cart_id}</p>`,
            });
          });
      });
    },

    showCart() {
      this.bus.$emit("showCart");
    },

    async removeItems(items) {
      let remove_items = [];

      for (let item of items) {
        if (item.product_description.indexOf("Design ID") > -1) {
          remove_items.push(item);
        }
      }

      let updates = {};
      for (let item of remove_items) {
        updates[item.id] = 0;
      }

      await axios.post("/cart/update.js", { updates: updates });

      return true;
    },

    async addItems(items) {
      let add_items = [];

      let products = [];
      for (let item of items) {
        if (item.product_description.indexOf("Design ID") > -1) {
          let design_id = item.product_description.split("Design ID:")[1];
          design_id = design_id.split(" // ")[0].trim();

          this.design_links.push(
            `https://studio.feltright.com/preview/${design_id}`
          );

          let productArray = item.product_description
            .split("Products: ")[1]
            .trim()
            .split("|");
          for (let i in productArray) {
            let product = productArray[i].split(":");

            let existingIndex = null;

            for (let p in products) {
              let data = products[p];
              if (data.id == product[0]) {
                existingIndex = p;
              }
            }
            if (!existingIndex) {
              products.push({
                id: product[0],
                quantity: parseFloat(product[1]) * item.quantity,
                // parent_quantity: item.quantity
              });
            } else {
              products[existingIndex].quantity +=
                parseFloat(product[1]) * item.quantity;
            }
          }
        }
      }
      if (products.length) {
        await axios.post("/cart/add.js", { items: products });
      }

      return true;
    },

    checkoutV2() {
      this.checkingOut = true;
      Shopify.getCart(async (cart) => {
        let items_processed = [];

        // axios.post('https://solatile.zenflare.com/email-design-previews', {items: cart.items, customer: storage.customer});

        let cartItems = cart.items;
        await this.removeItems(cart.items);
        await this.addItems(cartItems);

        if (this.design_links && this.design_links.length) {
          await axios.post("/cart/update.js", {
            note: `${this.design_links.join(", ")}`,
          });
        }

        location.href = "/checkout";
        // window.hulkappsCheckout();
      });
    },

    addUpsell(upsell) {
      this.addingUpsell = upsell.title;
      let items = [
        {
          id: upsell.variants[0].id,
          quantity: 1,
        },
      ];

      axios.post("/cart/add.js", { items: items }).then((response) => {
        // location.reload();
        this.addingUpsell = false;
        this.bus.$emit("showCart");
      });
    },

    hasTabs(item) {
      let hasTabs = true;

      // if(item.product_description && !item.product_description.includes('Design ID:')) {
      //   hasTabs = false;
      // }

      let noTabs = [
        // 'large-orange-pumpkin-3d-felt-decoration',
        // 'large-black-pumpkin-3d-felt-decoration',
        // 'spooky-tree-3d-felt-decoration',
        // 'jack-olantern-black-3d-felt-decoration',
        // 'jack-olantern-orange-3d-felt-decoration',
        // 'ghost-3d-felt-decoration',
        // 'small-orange-pumpkin-3d-felt-decoration',
        // 'small-black-pumpkin-3d-felt-decoration',
        // '4-piece-halloween-set-3d-felt-decorations',
      ];
      if (
        this.productDetails &&
        this.productDetails[item.handle] &&
        this.productDetails[item.handle].tags.includes("No Tabs")
      ) {
        // console.log(this.productDetails[item.handle], "product details");
        hasTabs = false;
      }
      if (item.title.includes("Partition") || noTabs.includes(item.handle)) {
        hasTabs = false;
      }
      return hasTabs;
    },

    async getUpsells() {
      let hasHex = false;
      let hasTile = false;
      let upsellHandles = [];

      let cart = await axios.get("/cart.js");
      cart = cart.data;

      this.upsells = [];

      for (let item of cart.items) {
        if (item.variant_id == 38403447357609) continue;
        if (item.variant_id == 31624916664400) continue;
        if (item.variant_id == 42334905893092) continue;
        if (item.variant_id == 37500128919721) continue;

        if (!item.product_description.includes("Design ID:")) {
          if (item.title.includes("Hex") || item.title.includes("Diamond")) {
            hasHex = true;
          } else {
            hasTile = true;
          }
        } else {
          let products = [];
          let productArray = item.product_description
            .split("Products: ")[1]
            .trim()
            .split("|");
          for (let i in productArray) {
            let item = productArray[i].split(":");
            products.push({
              variant_id: item[0],
              quantity: item[1],
            });
          }

          for (let product of products) {
            let title = this.variantTitle[product.variant_id];
            if (!title) continue;

            if (title.includes("Hex") || title.includes("Diamond")) {
              hasHex = true;
            } else {
              hasTile = true;
            }
          }
        }
      }

      if (hasTile) {
        upsellHandles.push("square-1-spacer-2-pack");
      }
      if (hasHex > 0) {
        upsellHandles.push("hex-1-spacer-2-pack");
      }
      // upsellHandles.push('peel-and-stick-adhesive-set');
      // upsellHandles.push('industrial-adhesive-tabs');

      for (let handle of upsellHandles) {
        let product = await axios.get(`/products/${handle}.js`);
        if (product.data.title.includes("Paint-Safe"))
          product.data.title = "Paint Safe Adhesive Pack";
        if (product.data.title.includes("Commercial Grade"))
          product.data.title = "Semi-Permanent Commercial Adhesive Tabs";
        this.upsells.push(product.data);
      }
    },

    itemClass(item) {
      let itemClass = "regular";

      if (item.title.includes("Shiplap")) {
        itemClass = "Shiplap";
      }
      if (item.title.includes("Quarter")) {
        itemClass = "Quarter";
      }
      if (item.title.includes("Pixel")) {
        itemClass = "Pixel";
      }

      return itemClass;
    },

    calcAdhesives(toggle) {
      this.transition = true;
      Shopify.getCart(async (response) => {
        let cart = response;

        if (toggle) {
          if (this.commercialTabs) {
            for (let item of this.cart.items) {
              if (!this.storage.semiPermanent.includes(item.id)) {
                this.storage.semiPermanent.push(item.id);
              }
            }
          } else {
            this.storage.semiPermanent = [];
          }
        }

        // let totalTabs = 0;
        let totalSheets = 0; // Combined total of regular + commercial adhesvies
        let totalRegular = 0; // Regular adhesive count
        let totalCommercial = 0; // Commercial Adhesive count
        let totalMiniAdhesives = 0; // Mini adhesives used primarily in Minecraft Products

        let totalHex = 0;
        // let hexSpacersInCart = 0;
        // let hexSpacersNeeded = 0;

        let commercialTabID = 42918340886756;
        let tabID = 37500128919721;
        let miniAdhesiveID = 45111050698980;

        // if(!this.commercialTabs) {
        //   // Remove any commercial tabs
        //   Shopify.changeItem(commercialTabID, 0, function(response) {
        //     // location.reload();
        //   });
        // }
        // if(this.commercialTabs) {
        //   // Remove any regular tabs
        //   Shopify.changeItem(tabID, 0, function(response) {
        //     // location.reload();
        //   });
        // }

        // console.log(cart.items, "cart items");
        for (let item of cart.items) {
          let bundleProductHTML = await axios.post(
            "https://studio.feltright.com/get-product-bundle",
            { product_id: item.product_id }
          );
          if (
            bundleProductHTML &&
            bundleProductHTML.data &&
            bundleProductHTML.data.html
          ) {
            item.product_description = bundleProductHTML.data.html;
          }
        }

        for (let item of cart.items) {
          // if(item.variant_id == 42334905893092) { // How many hex spacers are in cart
          //   hexSpacersInCart = item.quantity;
          // }
          try {
            let productDetails = await axios.get(`/products/${item.handle}.js`);
            productDetails = productDetails.data;
            if (productDetails && productDetails.tags.includes("No Tabs"))
              continue; // Skip products tagged as No Tabs
          } catch (error) {
            console.error(error.message, "error getting product details");
          }

          if (item.gift_card) continue;
          if (item.variant_id == 38403447357609) continue;
          if (item.variant_id == 31624916664400) continue;
          if (item.variant_id == 42334905893092) continue;
          if (item.variant_id == miniAdhesiveID) continue;
          if (item.handle == "copy-of-chess-pieces") continue;
          if (item.handle == "chess-pieces") continue;
          if (item.handle == "tic-tac-toe-pieces") continue;
          if (item.variant_id == tabID) continue;
          if (item.variant_id == commercialTabID) continue;
          if (item.title.includes("Route")) continue;

          let numSheets = 1 * item.quantity;

          // How many tabs are already in cart
          if (item.variant_id == tabID || item.variant_id == commercialTabID) {
            numSheets = 0;
            // totalTabs = item.quantity;
          }

          if (item.handle == "3-piece-wall-snowflake-set") {
            numSheets = 4;
          }
          if (
            !item.product_description.includes("Design ID:") &&
            this.variantData[item.variant_id]
          ) {
            numSheets =
              parseFloat(this.variantData[item.variant_id].total_tabs) *
              item.quantity;
          }
          if (item.product_description.includes("Design ID:")) {
            numSheets = 0;

            let products = [];
            let productArray = item.product_description
              .split("Products: ")[1]
              .trim()
              .split("|");
            for (let i in productArray) {
              let item = productArray[i].split(":");
              products.push({
                variant_id: item[0],
                quantity: item[1],
              });
            }

            for (let product of products) {
              if (this.variantData[product.variant_id]) {
                numSheets +=
                  parseFloat(this.variantData[product.variant_id].total_tabs) *
                  product.quantity *
                  item.quantity;
              }
            }
          }

          // console.log(item, "calculating tabs for item");
          // Add tabs for Checkers / Chess items
          if (
            item?.title?.includes("Checkers") &&
            item?.title?.includes("Standard")
          ) {
            numSheets = item.quantity * 16;
          }
          if (
            item?.title?.includes("Chess") &&
            item?.title?.includes("Standard")
          ) {
            numSheets = item.quantity * 16;
          }
          if (
            item?.title?.includes("Checkers") &&
            item?.title?.includes("Deluxe")
          ) {
            numSheets = item.quantity * 25;
          }
          if (
            item?.title?.includes("Chess") &&
            item?.title?.includes("Deluxe")
          ) {
            numSheets = item.quantity * 25;
          }
          if (item?.title?.includes("Tic-Tac-Toe Board")) {
            numSheets = item.quantity * 9;
          }

          // Tabs for elizabeth olwen products
          if (
            item?.title?.includes("Checker Daisy") ||
            item?.title?.includes("Daisy Checker")
          ) {
            numSheets = item.quantity * 16;
          }
          if (item?.title?.includes("Shape Play")) {
            numSheets = item.quantity * 18;
          }
          if (item?.title?.includes("Color Curve")) {
            numSheets = item.quantity * 28;
          }
          if (item?.title?.includes("New Horizons")) {
            numSheets = item.quantity * 35;
          }

          if (item?.title?.includes("Minecraft")) {
            let miniQuantity = 4;

            if (item.title.includes("4-Piece Bouquet")) miniQuantity = 15;
            if (item.title.includes("7-Piece Bouquet")) miniQuantity = 19;
            if (item.title.includes("Alex")) miniQuantity = 4;
            if (item.title.includes("Allium")) miniQuantity = 3;
            if (item.title.includes("Arctic Fox")) miniQuantity = 4;
            if (item.title.includes("Axolotl Gold")) miniQuantity = 6;
            if (item.title.includes("Axolotl Gold (Large)")) miniQuantity = 6;
            if (item.title.includes("Axolotl Leucistic")) miniQuantity = 6;
            if (item.title.includes("Axolotl Leucistic (Large)"))
              miniQuantity = 6;
            if (item.title.includes("Axolotls")) miniQuantity = 11;
            if (item.title.includes("Azure Bluet")) miniQuantity = 3;
            if (item.title.includes("Bee")) miniQuantity = 4;
            if (item.title.includes("Calico Cat")) miniQuantity = 2;
            if (item.title.includes("Chicken")) miniQuantity = 2;
            if (item.title.includes("Chicken (Large)")) miniQuantity = 2;
            if (item.title.includes("Chicken, Sniffer, Cat, and Bee"))
              miniQuantity = 14;
            if (item.title.includes("Cornflower")) miniQuantity = 3;
            if (item.title.includes("Crafting Table")) miniQuantity = 16;
            if (item.title.includes("Creeper")) miniQuantity = 4;
            if (item.title.includes("Creeper (Large)")) miniQuantity = 4;
            if (item.title.includes("Dandelion")) miniQuantity = 2;
            if (item.title.includes("Diamond Sword")) miniQuantity = 6;
            if (item.title.includes("Diamond Sword and Crafting Table"))
              miniQuantity = 22;
            if (item.title.includes("Ender Dragon")) miniQuantity = 18;
            if (item.title.includes("Ender Dragon (Large)")) miniQuantity = 18;
            if (item.title.includes("Enderman")) miniQuantity = 4;
            if (item.title.includes("Enderman and Ender Dragon"))
              miniQuantity = 22;
            if (item.title.includes("Fox")) miniQuantity = 4;
            if (item.title.includes("Fox (Large)")) miniQuantity = 4;
            if (item.title.includes("Foxes")) miniQuantity = 8;
            if (item.title.includes("Goat")) miniQuantity = 5;
            if (item.title.includes("Goat (Large)")) miniQuantity = 5;
            if (item.title.includes("Large Chicken, Fox, and Goat"))
              miniQuantity = 10;
            if (item.title.includes("Large Steve and Large Creeper"))
              miniQuantity = 8;
            if (item.title.includes("Lily of the Valley")) miniQuantity = 4;
            if (item.title.includes("Llama")) miniQuantity = 6;
            if (item.title.includes("Llama and Goat")) miniQuantity = 10;
            if (item.title.includes("Oxeye Daisy")) miniQuantity = 4;
            if (item.title.includes("Panda")) miniQuantity = 11;
            if (item.title.includes("Panda (Large)")) miniQuantity = 11;
            if (item.title.includes("Pig")) miniQuantity = 4;
            if (item.title.includes("Sheep")) miniQuantity = 4;
            if (item.title.includes("Skeleton")) miniQuantity = 4;
            if (item.title.includes("Skeleton and Zombie")) miniQuantity = 8;
            if (item.title.includes("Small Grass Block")) miniQuantity = 4;
            if (item.title.includes("Sniffer")) miniQuantity = 8;
            if (item.title.includes("Steve")) miniQuantity = 4;
            if (item.title.includes("Steve (Large)")) miniQuantity = 4;
            if (item.title.includes("Torchflower")) miniQuantity = 7;
            if (item.title.includes("Tulips")) miniQuantity = 11;
            if (item.title.includes("Warden")) miniQuantity = 23;
            if (item.title.includes("Zombie")) miniQuantity = 4;

            totalMiniAdhesives += item.quantity * miniQuantity;
            numSheets = 0;
          }

          totalSheets += numSheets;

          if (this.storage.semiPermanent.includes(item.id)) {
            totalCommercial += numSheets;
          } else {
            totalRegular += numSheets;
          }
        }

        totalSheets = Math.ceil(totalSheets);
        totalRegular = Math.ceil(totalRegular);
        totalCommercial = Math.ceil(totalCommercial);
        totalMiniAdhesives = Math.ceil(totalMiniAdhesives);

        this.totalAdhesiveSheets = totalSheets;
        this.totalRegularSheets = totalRegular;
        this.totalCommercialSheets = totalCommercial;
        this.totalMiniAdhesives = totalMiniAdhesives;

        this.$forceUpdate();

        // console.log(
        //   totalSheets,
        //   totalRegular,
        //   totalCommercial,
        //   totalMiniAdhesives,
        //   "totalSheets, totalRegular, totalCommercial, totalMiniAdhesives"
        // );

        if (totalHex >= 2) {
          // hexSpacersNeeded = 1;
          // this.totalHexSpacers = 1;
        } else {
          hexSpacersNeeded = 0;
        }

        let reloadNeeded = false;

        let updates = {};
        updates[commercialTabID] = totalCommercial;
        updates[tabID] = totalRegular;
        updates[miniAdhesiveID] = totalMiniAdhesives;
        // console.log(updates, "updates incoming");
        axios.post("/cart/update.js", { updates }).then((response) => {
          this.cart.items = response.data.items;
          this.transition = false;
        });

        // if(totalSheets != totalTabs) {
        //   if(!this.commercialTabs) {
        //     if(!totalTabs) {
        //       Shopify.addItem(tabID, totalSheets, function(response) {
        //         location.reload();
        //       });
        //     } else {
        //       Shopify.changeItem(tabID, totalSheets, function(response) {
        //         location.reload();
        //       });
        //     }
        //   }
        //   if(this.commercialTabs) {
        //     if(!totalTabs) {
        //       Shopify.addItem(commercialTabID, totalSheets, function(response) {
        //         location.reload();
        //       });
        //     } else {
        //       Shopify.changeItem(commercialTabID, totalSheets, function(response) {
        //         location.reload();
        //       });
        //     }
        //   }
        // }

        // console.log(hexSpacersInCart, hexSpacersNeeded, 'hexSpacersInCart, hexSpacersNeeded');
        // Switched this to have them manually add
        // if(hexSpacersInCart != hexSpacersNeeded) {
        //   if(!hexSpacersInCart) {
        //     Shopify.addItem(42334905893092, hexSpacersNeeded, function(response) {
        //       location.reload();
        //     });
        //   } else {
        //    Shopify.changeItem(42334905893092, hexSpacersNeeded, function(response) {
        //      location.reload();
        //    });
        //   }
        // }

        // if(totalSheets == totalTabs) {
        //   this.totalSheets = totalSheets;
        //   this.transition = false;
        //   this.$forceUpdate();
        // }
      });
    },

    openTileBreakout(item) {
      if (this.showBreakout == item.id) {
        this.showBreakout = null;
      } else {
        this.showBreakout = item.id;
      }
    },

    getCart() {
      this.grabbingCart = true;

      axios.get("/cart.js").then(async (response) => {
        this.cart = response.data;

        // console.log(this.cart, "cart found");

        this.cart.total_price = this.cart.total_price;

        for (let item of this.cart.items) {
          try {
            let productDetails = await axios.get(`/products/${item.handle}.js`);
            productDetails = productDetails.data;
            this.productDetails[item.handle] = productDetails;
          } catch (error) {
            console.error(item, error.message, "error getting product details");
          }

          if (item.discounts && item.discounts.length) {
            for (let discount of item.discounts) {
              if (!this.discountMessages.includes(discount.title)) {
                this.discountMessages.push(discount.title);
              }
            }
          }
        }

        // Get Cart Bundle Products if applicable
        // for(let i in this.cart.items) {
        //   let item = this.cart.items[i];
        //   let bundleHTML = await axios.post('https://studio.feltright.com/get-product-bundle', {product_id: item.product_id});
        //   if(bundleHTML.data.html) {
        //     item.product_description = bundleHTML.data.html;
        //     this.cart.items[i] = item;
        //   }
        // }
        this.grabbingCart = false;
        this.bus.$emit("refreshCart");
        this.$forceUpdate();
      });
    },

    designID(data) {
      let design_id = data.split("Design ID:")[1];
      design_id = design_id.split(" // ")[0].trim();

      return design_id;
    },

    tileListHTML(data) {
      let design_id = data.split("Design ID:")[1];
      design_id = design_id.split(" // ")[0].trim();
      let products = [];
      let productArray = data.split("Products: ")[1].trim().split("|");
      for (let i in productArray) {
        let item = productArray[i].split(":");
        products.push({
          variant_id: item[0],
          quantity: item[1],
        });
      }

      // console.log(products, "products found");

      let html = ``;

      for (let i in products) {
        let item = products[i];

        let title = this.variantTitle[item.variant_id];

        if (!title) continue;

        let tileType = "Tile";

        if (title.includes("Pixel")) {
          tileType = "Pixel";
        }
        if (title.includes("Quarter")) {
          tileType = "Quarter";
        }
        if (title.includes("Shiplap")) {
          tileType = "Shiplap";
        }
        if (title.includes("Halflap")) {
          tileType = "Halflap";
        }

        let price = this.variantPricing[item.variant_id] / 100;

        if (tileType == "Pixel") {
          if (item.quantity >= 10) {
            price = 0.8;
          }
        }

        let subTotal = parseFloat(price * item.quantity).toFixed(2);
        // <div class="name">${this.tileVariantTitle[item.variant_id]}</div>

        html += `
          <div class="tile ${tileType}">
            <div class="tileImage"><img data-swift-lazy="1" loading="lazy" src="${
              this.variantImage[item.variant_id]
            }"></div>
            <div class="details">
              <div class="tileName">${title}</div>
              <div class="quantity">$${price} x ${
          item.quantity
        } ($${subTotal})</div>
            </div>
          </div>
        `;
      }

      // html += `</div>`;

      return html;
    },

    getShopifyImage(data = {}) {
      let image = data.image;

      if (!image) return "";

      let extension = data.extension || ".jpg";
      if (image.includes("png")) extension = ".png";
      if (image.includes("jpg")) extension = ".jpg";
      if (image.includes("gif")) extension = ".gif";

      if (data.width) {
        image = image.split(extension);
        image[0] += "_";
        image[0] += `${data.width}x`;
        image = image.join(extension);
      }
      if (data.height) {
        // if(!image.includes('x.jpg')) {
        //   image = image.split(extension);
        //   image[0] += '_x';
        //   image = image.join(extension);
        // }
        image = image.split(extension);
        image[0] += data.height;
        image = image.join(extension);
      }

      if (data.crop) {
        image = image.split(extension);
        image[0] += `_crop_${data.crop}`;
        image = image.join(extension);
      }

      return image;
    },

    setCookie(cname, cvalue, exdays) {
      if (!exdays) exdays = 30;
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie =
        cname + "=" + cvalue + ";samesite=none;secure;" + expires + ";path=/";
    },

    increaseItemQuantity(item) {
      this.grabbingCart = true;
      let newQuantity = parseFloat(item.quantity) + 1;

      let updates = {};
      updates[item.variant_id] = newQuantity;

      axios
        .post("/cart/update.js", {
          updates: updates,
        })
        .then((response) => {
          this.getCart();
          this.calcAdhesives();
          this.bus.$emit("refreshCart");
        });
    },

    decreaseItemQuantity(item) {
      this.grabbingCart = true;
      let newQuantity = parseFloat(item.quantity) - 1;

      if (newQuantity <= 0) newQuantity = 0;

      let updates = {};
      updates[item.variant_id] = newQuantity;

      axios
        .post("/cart/update.js", {
          updates: updates,
        })
        .then((response) => {
          this.getCart();
          this.calcAdhesives();
          this.bus.$emit("refreshCart");
        });
    },

    removeCartItem(item) {
      this.grabbingCart = true;

      newQuantity = 0;

      let updates = {};
      updates[item.variant_id] = newQuantity;

      axios
        .post("/cart/update.js", {
          updates: updates,
        })
        .then((response) => {
          this.getCart();
          this.calcAdhesives();
          this.bus.$emit("refreshCart");
        });
    },

    clearCart() {
      axios.post("/cart/clear.js").then((response) => {
        this.calcAdhesives();
        this.getCart();
      });
    },

    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c && c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        } else {
          // console.log('getCookie is undefined')
        }
      }
      return null;
    },

    deleteCookie(cname) {
      var expires = "expires=Thu, 01 Jan 1970 00:00:00 UTC";
      document.cookie = cname + "=;samesite=none;secure;" + expires + ";path=/";
    },

    tileImage(tile) {
      var item = tile;
      var data = { image: "", width: 100, height: 100 };
      if (this.variationObject(tile.tile)) {
        data = {
          image: this.variationObject(tile.tile).photo,
          width: 100,
          height: 100,
        };

        if (item.tile.shape == "Quarter") {
          data.width = 50;
          data.height = 50;
        }
        if (item.tile.shape == "Half") {
          data.width = 100;
          data.height = 50;
        }
        if (item.tile.shape == "Shiplap") {
          data.width = 200;
          data.height = 50;
        }
        if (item.tile.shape == "Pixel") {
          data.width = 25;
          data.height = 25;
        }
        if (item.tile.shape == "MiniShiplap") {
          data.width = 100;
          data.height = 25;
        }
        if (item.tile.shape == "Hex") {
          data.width = 100;
          data.height = 86;
        }
        if (item.tile.shape == "Diamond") {
          data.width = 50;
          data.height = 86;
        }
        if (item.tile.shape == "LargeDiamond") {
          data.width = 100;
          data.height = 150;
        }
        if (item.tile.shape == "LargeHalflap") {
          data.width = 200;
          data.height = 100;
        }
      }
      // console.log(data, "Tile data to return");
      return data;
    },

    shapeImage(shape) {
      var data = {
        image: shape.image,
      };

      if (shape.label == "Tile") {
        data.image =
          this.variationDetails[
            this.storage.chosenColor.label +
              "-" +
              this.storage.chosenPattern.label
          ].photo;
        data.width = 50;
        data.height = 50;
      }
      if (shape.label == "Hex") {
        data.image =
          this.variationDetails[
            shape.label + "-" + this.storage.chosenColor.label
          ].photo;
        data.width = 50;
        data.height = 43;
      }
      if (shape.label == "Diamond") {
        data.image =
          this.variationDetails[
            shape.label + "-" + this.storage.chosenColor.label
          ].photo;
        data.width = 50;
        data.height = 87;
      }
      // if(shape.label == 'Quarter') {
      //  data.image = shape.image;
      //  data.width = 25;
      //  data.height = 25;
      // }

      if (
        shape.label == "Half" ||
        shape.label == "Quarter" ||
        shape.label == "Shiplap" ||
        shape.label == "Triangle" ||
        shape.label == "Pixel"
      ) {
        data.image =
          this.variationDetails[
            shape.label + "-" + this.storage.chosenColor.label
          ].photo;
        data.width = 50;
        data.height = 50;
      }
      if (shape.label == "Half") {
        data.width = 100;
        data.height = 50;
      }
      if (shape.label == "Shiplap") {
        data.width = 200;
        data.height = 50;
      }
      if (shape.label == "Pixel") {
        data.width = 12;
        data.height = 12;
      }

      return data;
    },

    totalDraggable(tiles) {
      var total = 0;
      for (var i in tiles) {
        var tile = tiles[i];
        total += this.tileCost(tile);
      }

      total = parseFloat(parseFloat(total).toFixed(2));

      return total;
    },

    tileData(tile) {
      let data = tile;

      for (let shape of shapeChoices) {
        if (tile.shape == shape.label) {
          data.shapeData = shape;
        }
      }

      for (let pattern of patternChoices) {
        if (tile.pattern == pattern.label) {
          data.patternData = pattern;
        }
      }

      for (let color of colorChoices) {
        if (tile.color == color.label) {
          data.colorData = color;
        }
      }

      if (!data.shapeData) data.shapeData = {};
      if (!data.patternData) data.patternData = {};
      if (!data.colorData) data.colorData = {};

      return data;
    },

    addFilter(list, category) {
      this.renderFilters = false;
      if (!list.includes(category)) {
        list.push(category);
      } else {
        list.splice(list.indexOf(category), 1);
      }
      this.$forceUpdate();

      this.grabFilteredDesigns();

      this.$nextTick(() => {
        this.renderFilters = true;
      });
    },
    setSortPosition(category) {
      if (this.designs) {
        for (let design of this.designs) {
          if (typeof design.category_position[category] != "undefined") {
            design.sorted_position = parseInt(
              design.category_position[category]
            );
          } else {
            design.sorted_position = design.position + 10000;
          }
        }

        // Sometimes alasql is not defined yet. Not sure what the difference is between these two sorting methods.
        if (window.alasql) {
          this.designs = alasql(`SELECT * FROM ? ORDER BY sorted_position`, [
            this.designs,
          ]);
        } else {
          this.designs = this.designs.sort(
            (a, b) => a.sorted_position - b.sorted_position
          );
        }
      }
    },
    clearFilters(spacesPage) {
      this.storage.designTypeFilters = [];
      this.storage.colorFilter = [];
      // console.log("Clearing filters");
      if (spacesPage) {
        switch (spacesPage) {
          case "office":
            this.storage.roomTypeFilter = ["Office"];
            break;
          case "living":
            this.storage.roomTypeFilter = ["Living Spaces"];
            break;
          case "family":
            this.storage.roomTypeFilter = ["Family / Kitchen Organization"];
            break;
          case "podcast":
            this.storage.roomTypeFilter = ["Podcast / Recording Studio"];
            break;
          case "headboard":
            this.storage.roomTypeFilter = ["Headboard"];
            break;
          case "kids":
            this.storage.roomTypeFilter = ["Kids / Classroom"];
            break;
        }
      } else this.storage.roomTypeFilter = [];
      this.storage.categoryFilter = [];
      this.allDesignTypes = false;
      this.categoryTypeFilter = null;
      this.storage.designsPage = 0;

      this.renderFilters = false;
      this.$nextTick(() => {
        this.renderFilters = true;
      });

      this.setSortPosition("Felt Right Design");
    },
    pixelsToInch(pixels, options) {
      if (!options) options = {};
      if (options.precise) {
        return (pixels / 100) * 11.875;
      } else {
        return (pixels / 100) * 12;
      }
    },
    tileCost(tile, log) {
      if (log) {
        // console.log(tile, "getting tile cost");
        // console.log(this.variationObject(tile), "variation object");
      }
      if (this.variationObject(tile)) {
        return this.variationObject(tile).price || 0;
      } else {
        return 0;
      }
    },
    variationObject(tile) {
      var obj = {};

      let pattern, shape, color;

      if (typeof tile.color == "object") {
        pattern = tile.pattern ? tile.pattern.label : "";
        shape = tile.shape ? tile.shape.label : "";
        color = tile.color ? tile.color.label : "";
      }

      if (typeof tile.color == "string") {
        pattern = tile.pattern || "Blank";
        shape = tile.shape || "Tile";
        color = tile.color || "Admiral";
      }

      if (shape == "Square") shape = "Tile";

      if (!tile.pattern) {
        tile.pattern = "Blank";
      }

      if (!shape || shape == "Tile")
        obj = this.variationDetails[color + "-" + pattern];
      if (shape && shape != "Tile")
        obj = this.variationDetails[shape + "-" + color];
      if (shape && (shape == "Hex" || shape == "Diamond"))
        obj = this.variationDetails[shape + "-" + color];

      if (!obj) obj = {};
      return obj;
    },
    dimensionsOutput(totalInches) {
      var parts = 0;
      try {
        parts = math.fraction(
          parseFloat("0." + (totalInches % 12).toString().split(".")[1])
        );
        if (parts.n > 0) {
          parts = `${parts.n}/${parts.d}`;
        }
      } catch (error) {
        parts = 0;
      }

      var ft = Math.floor(totalInches / 12);
      var inches = Math.floor(totalInches % 12);

      var dimensions = `${ft}ft ${inches}in`;

      if (inches == 0) {
        dimensions = `${ft}ft`;
      }

      // if (parts != 0) {
      //   dimensions = `${ft}ft ${inches}in ${parts}in`;
      // }

      return dimensions;
    },

    async grabCategories(parameters) {
      axios
        .post("https://studio.feltright.com/grab-categories")
        .then((response) => {
          this.designCategories = response.data;
        });
    },

    async grabDesigns(category) {
      return new Promise(async (resolve) => {
        this.grabbingDesigns = true;
        // console.log(category, "category grabbing");

        let path = "https://studio.feltright.com/grab-express-designs";
        // let ip = await axios.get('https://api.ipify.org?format=json');
        // ip = ip.data.ip;
        // console.log(ip, 'IP FOUND');
        // if(ip == '38.70.255.250') {
        //   path = 'http://localhost:3000/grab-express-designs';
        // }

        axios.post(path, { category: category }).then((response) => {
          this.designs = response.data;
          this.grabbingDesigns = false;

          if (this.storage.designTypeFilters.length == 1) {
            this.setSortPosition(this.storage.designTypeFilters[0]);
          }
          if (this.storage.colorFilter.length == 1) {
            // console.log("setting sort position", this.storage.colorFilter[0]);
            // console.log(this.designs, "do designs exist?");
            this.setSortPosition(this.storage.colorFilter[0]);
          }
          if (this.storage.roomTypeFilter.length == 1) {
            this.setSortPosition(this.storage.roomTypeFilter[0]);
          }
          if (this.storage.categoryFilter.length == 1) {
            this.setSortPosition(this.storage.categoryFilter[0]);
          }
          if (category) {
            // console.log(category, "setting sort position category");
            this.setSortPosition(category);
          }

          // console.log(this.designs, "designs found");

          this.$forceUpdate();
          resolve();
        });
      });
    },

    async grabVariations() {
      if (!grabbingVariations) {
        grabbingVariations = true;
        setTimeout(() => {
          axios
            .post(`https://studio.feltright.com/grab-variations`)
            .then((response) => {
              let variations = response.data;

              this.bus.$emit("variationDetailsReady", variations);

              grabbingVariations = false;
            });
        }, 100);
      }
    },

    elementDimensions(data) {
      let tile = data.tile;
      if (!tile) return;
      let shape = tile.shape.label;

      if (tile.shape.modifier) {
        shape = `${tile.shape.label}-${tile.shape.modifier}`;
      }

      let style = {};

      if (shape == "Tile" || shape == "Tile-90") {
        style.width = "100px";
        style.height = "100px";
      }
      if (shape == "Pixel") {
        style.width = "25px";
        style.height = "25px";
      }
      if (shape == "Quarter") {
        style.width = "50px";
        style.height = "50px";
      }
      if (shape == "Half") {
        style.width = "100px";
        style.height = "50px";
      }
      if (shape == "Half-Vertical") {
        style.width = "50px";
        style.height = "100px";
      }
      if (shape == "Triangle") {
        style.width = "100px";
        style.height = "100px";
      }
      if (shape == "Triangle-TopLeft") {
        style.width = "100px";
        style.height = "100px";
      }
      if (shape == "Triangle-TopRight") {
        style.width = "100px";
        style.height = "100px";
      }
      if (shape == "Triangle-BottomRight") {
        style.width = "100px";
        style.height = "100px";
      }
      if (shape == "Shiplap") {
        style.width = "200px";
        style.height = "50px";
      }
      if (shape == "Shiplap-Vertical") {
        style.width = "50px";
        style.height = "200px";
      }
      if (shape == "Hex") {
        style.width = "98px";
        style.height = "86px";
      }
      if (shape.includes("Diamond")) {
        style.width = "50px";
        style.height = "86px";
      }

      return style;
    },

    smoothScroll(data) {
      let item = document.querySelector(data.element);
      let scroller = window;
      if (data.scroller) scroller = document.querySelector(data.scroller);
      let offset = data.offset || 0;
      let speed = data.speed || 5; // Lower is faster 0 is instant

      let isWindowScroll = true;
      if (data.scroller) isWindowScroll = false;

      let scrollY = scroller.scrollY || scroller.scrollTop;

      var diff = (item.offsetTop - scrollY + offset) / speed;

      if (!scroller._lastDiff) {
        scroller._lastDiff = 0;
      }

      if (Math.abs(diff) > 2) {
        if (isWindowScroll) {
          scroller.scrollTo(0, scrollY + diff);
        } else {
          scroller.scrollTop = scrollY + diff;
        }
        clearTimeout(scroller._TO);

        if (diff !== scroller._lastDiff) {
          scroller._lastDiff = diff;
          scroller._TO = setTimeout(this.smoothScroll, 15, {
            element: data.element,
            offset: data.offset,
            scroller: data.scroller,
          });
        }
      } else {
        if (isWindowScroll) {
          scroller.scrollTo(0, item.offsetTop);
        } else {
          scroller.scrollTop = scrollY + diff;
        }
      }
    },

    smoothScrollOLD(data) {
      setTimeout(() => {
        $("html, body").animate(
          { scrollTop: $(data.element).offset().top - 120 },
          100
        );
      }, 100);
    },

    scrollBodyTop() {
      $("html, body").animate({ scrollTop: 0 }, 500);
    },

    getParameter(name, url) {
      if (!url) {
        url = window.location.href;
      }
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },

    getImage(parameters) {
      if (parameters.image) {
        var image = parameters.image;
        var image = image.replace("http://", "https://");
        var imageSrc = image;
        var parameterArray = [];
        if (parameters.type) {
          parameterArray.push(parameters.type);
        }
        if (parameters.width) {
          parameterArray.push("w_" + parameters.width);
        }
        if (parameters.height) {
          parameterArray.push("h_" + parameters.height);
        }
        if (parameters.quality) {
          parameterArray.push("q_" + parameters.quality);
        }
        var parameterString = parameterArray.join();
        if (parameterString) {
          imageSrc = imageSrc.replace(
            "/image/upload/",
            "/image/upload/" + parameterString + "/"
          );
          imageSrc = imageSrc.replace(
            "/video/upload/",
            "/video/upload/" + parameterString + "/"
          );

          if (imageSrc.includes("/w_520/") && parameters.width) {
            imageSrc = imageSrc.replace("/w_520/", "/");
          }

          // var imageSrc = str_replace('/image/upload/', '/image/upload/'.$parameterString.'/', $imageSrc);
        }
        if (parameters.format) {
          imageSrc = imageSrc.replace(/.jpg/gi, parameters.format);
          imageSrc = imageSrc.replace(/.mp4/gi, parameters.format);
          imageSrc = imageSrc.replace(/.mov/gi, parameters.format);
          imageSrc = imageSrc.replace(/.png/gi, parameters.format);
          imageSrc = imageSrc.replace(/.gif/gi, parameters.format);
        }
        return imageSrc;
      }
    },
  },
};
